import * as actions from '../actions/auctionItemsActions';

export const initialState = {
  auctionItems: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_AUCTION_ITEMS:
      /**
       * Faster than JSON.stringify(state.auctionItems) === JSON.stringify(action.payload)
       */
      const update = (
        (state.auctionItems.length === 0 && action.payload.length === 0) ||
        (state.auctionItems.length !== action.payload.length) || // Short circuit
        (state.auctionItems.filter(auctionItem => {
          return action.payload.filter(item => {
            return (auctionItem.id === item.id);
          }).length > 0;
        }).length !== action.payload.length)
      );

      return {
        ...state,
        auctionItems: (update) ? action.payload : state.auctionItems
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/auctionItemsReducer.js